<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <b-container>
    <nav v-if="totalRows > perPage">
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" align="center">
        <template slot="prev-text"><i class="fa fa-backward"></i></template>
        <template slot="next-text"><i class="fa fa-forward"></i></template>
        <template slot="first-text"><i class="fa fa-step-backward"></i></template>
        <template slot="last-text"><i class="fa fa-step-forward"></i></template>
      </b-pagination>
    </nav>
    <b-table :dark="dark" :hover="hover" :striped="striped" :outlined="outlined" :bordered="bordered" :small="small"
             :fixed="fixed" responsive :items="items" :fields="captions" :current-page="currentPage"
             :per-page="perPage" thead-class="bg-light" :busy="fetching" show-empty>
      <template slot="table-busy">
        <div class="text-center">
          <b-spinner></b-spinner>
          <br>
          Chargement des données...
        </div>
      </template>
      <template slot="empty">
        <slot name="empty"></slot>
      </template>
      <template v-slot:cell(logo)="data">
        <b-image :src="data.item.logo" class="logo"></b-image>
      </template>
      <template v-slot:cell(picture)="data">
        <b-image :src="data.item.picture" class="preview-image"></b-image>
      </template>
      <template v-slot:cell(status)="data">
        <d-badge outline pill :theme="data.item.statusVariant">{{ data.item.status }}</d-badge>
      </template>
      <template v-slot:cell(actions)="data">
        <d-button v-for="(action, i) in actions" :key="i" :theme="action.type" @click="action.handler(data.item)"
                  :title="action.title" :outline="action.outline" class="mr-1" v-d-tooltip.hover>
          <i :class="action.icon"></i>
        </d-button>
      </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" align="center">
        <template slot="prev-text"><i class="fa fa-backward"></i></template>
        <template slot="next-text"><i class="fa fa-forward"></i></template>
        <template slot="first-text"><i class="fa fa-step-backward"></i></template>
        <template slot="last-text"><i class="fa fa-step-forward"></i></template>
      </b-pagination>
    </nav>
  </b-container>
</template>

<script>
export default {
  name: 'c-table',
  inheritAttrs: false,
  props: {
    fetching: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    actions: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    currentPage: 1,
    asset: path => path
  }),
  created() {
    const pictureField = this.fields.find(field => field.key === 'picture' || field.key === 'logo')
    if (pictureField)
      this.asset = pictureField.asset
  },
  computed: {
    items: function () {
      const items = this.tableData
      return Array.isArray(items) ? items : items()
    },
    totalRows: function () {
      return this.getRowCount()
    },
    captions: function () {
      return this.fields.map(field => ({...field, class: 'v-align-middle'}))
    }
  },
  methods: {
    getRowCount: function () {
      return this.items.length
    }
  }
}
</script>

<style scoped>
.preview-image {
  max-height: 50px;
  max-width: 100%;
}

.logo {
  max-height: 24px;
  max-width: 100%;
}
</style>
